import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3b5647b2")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Your file may be too big", -1)
const _hoisted_3 = { id: "info" }
const _hoisted_4 = { id: "error" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" It may cause performance issues while using our software. We recommend uploading a smaller file. ")
const _hoisted_6 = { class: "btns-wrap" }
_popScopeId()

import { inject } from "vue";
import { Ref } from "@vue/reactivity";
import CloseSVG from "@/components/CloseSVG.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    fileSize: { type: Number, required: true }
  },
  emits: ["continueAnyway", "uploadClick", "closeModalAndCleanInput"],
  setup(__props: any) {

// Vue 3.2 script setup api




const bounceTransition = inject("bounceTransition") as Ref<string>;
const fadeTransition = inject("fadeTransition") as Ref<string>;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(fadeTransition), "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_unref(bounceTransition), "modal-body"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            style: {"height":"30px","width":"30px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModalAndCleanInput')))
          }, [
            _createVNode(CloseSVG, { propId: 'file-size-close' })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_4, "The file size of your image (" + _toDisplayString(__props.fileSize) + ") is very large.", 1),
            _hoisted_5
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            "aria-label": "Continue anyway",
            id: "left-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('continueAnyway')))
          }, "Continue Anyway"),
          _createElementVNode("button", {
            "aria-label": "Upload a new image",
            id: "right-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('uploadClick')))
          }, "Upload a New Image")
        ])
      ], 2)
    ], 2)
  ]))
}
}

})